<template>
  <div>
    <!--<b-menu-list :label="$t('compTransitionDocsMenu.label-1')">
      <b-menu-item
        :active="
          buffer === 'transition-notes' ||
          buffer === 'transition-charter' ||
          buffer === 'transition-manual'
        "
        :expanded="
          buffer === 'transition-notes' ||
          buffer === 'transition-charter' ||
          buffer === 'transition-manual'
        "
        @click="activate('transition-notes')"
      >
        <template slot="label" slot-scope="props">
          <b-icon icon="life-ring"></b-icon>
          {{ $t('compTransitionDocsMenu.label-2') }}
          <b-icon
            class="is-pulled-right"
            :icon="props.expanded ? 'caret-down' : 'caret-up'"
          >
          </b-icon>
        </template>

        <b-menu-item
          :active="buffer === 'transition-notes'"
          @click="activate('transition-notes')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="warning"></b-icon>
                  {{ $t('compTransitionDocsMenu.label-3') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>

        <b-menu-item
          :active="buffer === 'transition-charter'"
          @click="activate('transition-charter')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="info-circle"></b-icon>
                  {{ $t('compTransitionDocsMenu.label-charter') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>

        <b-menu-item
          :active="buffer === 'transition-manual'"
          @click="activate('transition-manual')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="book"></b-icon>
                  {{ $t('compTransitionDocsMenu.label-4') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
      </b-menu-item>

      <b-menu-item
        :active="buffer === 'transition-team' || buffer === 'transition-thanks'"
        :expanded="
          buffer === 'transition-team' || buffer === 'transition-thanks'
        "
        @click="activate('transition-team')"
      >
        <template slot="label" slot-scope="props">
          <b-icon icon="users"></b-icon>
          <span v-html="$t('compTransitionDocsMenu.label-6')" />
          <b-icon
            class="is-pulled-right"
            :icon="props.expanded ? 'caret-down' : 'caret-up'"
          >
          </b-icon>
        </template>
        <b-menu-item
          :active="buffer === 'transition-team'"
          @click="activate('transition-team')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="keyboard-o"></b-icon>
                  {{ $t('compTransitionDocsMenu.label-7') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          :active="buffer === 'transition-thanks'"
          @click="activate('transition-thanks')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="thumbs-o-up"></b-icon>
                  {{ $t('compTransitionDocsMenu.label-8') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
      </b-menu-item>
    </b-menu-list> -->
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      buffer: this.value
    }
  },
  watch: {
    value: function () {
      this.buffer = this.value
    }
  },
  methods: {
    activate: function (val) {
      this.buffer = val
      this.$emit('input', this.buffer)
    }
  }
}
</script>
